import { chunk } from 'common/utils/arrayUtils'

export const capitalizeFirstLetter = str => str[0].toUpperCase() + str.slice(1)
export const capitalizeWords = str => str.split(' ').map(capitalizeFirstLetter).join(' ')
export const removeWhitespace = str => (str ? str.replace(/\s+/g, '') : '')
export const addStringEveryNChars = (str, toAdd, everyN) =>
  chunk(str.split(''), everyN).map(group => group.join('')).join(toAdd)
export const padWithZero = n => ((n < 10) ? `0${n}` : n)
